var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9963 12C24.9963 18.6274 19.6238 24 12.9963 24C6.36892 24 0.996338 18.6274 0.996338 12C0.996338 5.37258 6.36892 0 12.9963 0C19.6238 0 24.9963 5.37258 24.9963 12ZM13.319 7.80655C12.0293 8.34298 9.4517 9.45326 5.58624 11.1374C4.95855 11.387 4.62974 11.6312 4.5998 11.87C4.54921 12.2735 5.05455 12.4324 5.74268 12.6488C5.83628 12.6782 5.93327 12.7087 6.0327 12.741C6.70971 12.9611 7.62042 13.2185 8.09386 13.2288C8.52331 13.2381 9.00263 13.061 9.53182 12.6976C13.1434 10.2597 15.0078 9.02742 15.1248 9.00085C15.2074 8.98211 15.3218 8.95855 15.3994 9.02746C15.4769 9.09637 15.4693 9.22688 15.4611 9.26189C15.411 9.4753 13.4274 11.3194 12.4009 12.2738C12.0808 12.5713 11.8538 12.7824 11.8074 12.8305C11.7035 12.9385 11.5975 13.0406 11.4957 13.1388C10.8668 13.7451 10.3951 14.1998 11.5218 14.9423C12.0633 15.2991 12.4966 15.5942 12.9288 15.8886C13.4009 16.21 13.8718 16.5307 14.481 16.93C14.6362 17.0318 14.7844 17.1374 14.9288 17.2404C15.4781 17.632 15.9717 17.9839 16.5815 17.9278C16.9358 17.8952 17.3018 17.562 17.4877 16.5684C17.9269 14.2201 18.7904 9.132 18.9899 7.03533C19.0074 6.85164 18.9854 6.61654 18.9677 6.51334C18.9501 6.41014 18.9132 6.2631 18.779 6.15425C18.6202 6.02535 18.3749 5.99816 18.2652 6.00009C17.7665 6.00888 17.0013 6.27494 13.319 7.80655Z",
    fill: "#A7A2B8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.58be9aa9d2ab2424bb46bbba1cbbba96.svg";
export { ForwardRef as ReactComponent };